export default __webpack_public_path__ + "static/media/weather_02.fcf361c9.png";